import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import dynamic from "next/dynamic";
const Lottie = dynamic(() => import("lottie-react-web"), { ssr: false });
import launch from "../../public/assets/onboarding/launch.json";
import circularProgress from "../../public/assets/lottie/circularProgress.json";
import {
  forwardRef,
  useContext,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { BoardingFlowContext } from "../../context/auth/BoardingFlowContext";
import phoneVerification from "../../public/assets/onboarding/phone_verification.svg";
import phoneVerificationHand from "../../public/assets/onboarding/phone_verification_hand.svg";
import planetEarth from "../../public/assets/onboarding/planet_earth.svg";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";
import Image from "next/image";
import { BaseStepProps } from ".";
import Timer from "react-compound-timer";
import planet1 from "../../public/assets/onboarding/planet_1.svg";
import planet2 from "../../public/assets/onboarding/planet_2.svg";
import planet3 from "../../public/assets/onboarding/planet_3.svg";
import planet4 from "../../public/assets/onboarding/planet_4.svg";
import planet5 from "../../public/assets/onboarding/planet_5.svg";
import planet6 from "../../public/assets/onboarding/planet_6.svg";
import { useFormContext } from "react-hook-form";
import {
  getUserInfoById,
  uploadUserInfo,
  useBoardingFlow,
} from "../../hooks/useBoardingFlow";
import OTPInput from "react-otp-input";
import { submitPhoneNumberAuthCode } from "../../services/auth/index-new";
import { IntroContext } from "../../context";
import parsePhoneNumberFromString from "libphonenumber-js";

const planetsArray = [planet1, planet2, planet3, planet4, planet5, planet6];
const handMovementClasses = [
  " zero",
  " one",
  " two",
  " three",
  " four",
  " five",
  " six",
  " seven",
  " eight",
  " nine",
  "",
];

function MyOtpIsStep(props: BaseStepProps, ref: any) {
  const [launchRocket, setLaunchRocket] = useState(false);
  const [isPending, setIsPending] = useState(false);
  const [, setActiveTab] = useContext(BoardingFlowContext).activeTab;
  const [, setPhoneRoute] = useContext(BoardingFlowContext).phoneRoute;
  const [, setTempData] = useContext(BoardingFlowContext).tempData;
  const [allowNext, setAllowNext] = useState(false);
  const [otpCode, setOtpCode] = useState("");
  const [resendCode, setResendCode] = useState(false);
  const [plural, setPlural] = useState(true);
  const [afterVerifyData, setAfterVerifyData] = useState<{
    user?: firebase.User;
    res?: boolean;
    errorCode?: string;
    exists?: boolean;
  } | null>(null);
  //   const [lastInput, setLastInput] = useState(10);
  const authJourneyRef = useContext(IntroContext).authJourneyRef;
  const shouldAnimateHandRef = useRef(true);
  const { clearErrors, setValue, getValues, formState, setError } =
    useFormContext();
  const { signInWithPhone, loginUser } = useBoardingFlow();

  const lastInput = otpCode?.split("").pop();

  useImperativeHandle(ref, () => ({
    reset: () => {
      setLaunchRocket(false);
      setIsPending(false);
      setAllowNext(false);
      setOtpCode("");
      setResendCode(false);
      setPlural(true);
      shouldAnimateHandRef.current = true;
      setAfterVerifyData(null);
    },
  }));

  const handleSignInWithPhone = async () => {
    if (isPending) return;
    setIsPending(true);

    try {
      await require("../../firebase-config").auth.signOut();
      await require("../../firebase-config").messaging.deleteToken();
    } catch (e) {}

    // setPhoneRoute(true);
    clearErrors();
    signInWithPhone({
      phoneNumber: getValues("phoneNumber"),
      setIsPending,
      handleSuccess: () => {
        console.log("Setting Active Tab - ", 1);
        setIsPending(false);
      },
      handleError: (errorMessage) => {
        setIsPending(false);
        setError(
          "phoneNumber",
          {
            message:
              errorMessage ?? "Something went wrong. Please try again later.",
          },
          { shouldFocus: true }
        );
      },
    });
  };

  const verifyOTP = async (_otpCode: string) => {
    setIsPending(true);
    try {
      const afterVerifyData = await submitPhoneNumberAuthCode({
        code: _otpCode,
      });
      setTempData(afterVerifyData.user);

      if (!afterVerifyData.user) {
        setError("phoneNumber", {
          message: "Something went wrong. Please try again later.",
        });
        // props.reset();
        return;
      }
      // Set temp phone user data
      clearErrors();

      console.log("afterVerifyData.user - ", afterVerifyData.user);

      let userData = await getUserInfoById(afterVerifyData.user?.uid);
      const isCond =
        !userData.phone_number ||
        (!userData.email && afterVerifyData.user?.email) ||
        (!userData.name && afterVerifyData.user?.displayName);

      const parsedNumber = parsePhoneNumberFromString(
        afterVerifyData.user?.phoneNumber
      );
      if (isCond) {
        userData = await uploadUserInfo({
          userId: afterVerifyData.user?.uid,
          avatarUrl:
            afterVerifyData.user?.photoURL ?? userData?.profile_url ?? null,
          name: afterVerifyData.user?.displayName ?? userData?.name ?? null,
          email: afterVerifyData.user?.email ?? userData?.email ?? null,
          phoneNumber: parsedNumber.nationalNumber,
          countryCode: "+" + parsedNumber.countryCallingCode,
          isInstructor: false,
        });
      }

      // If user doesn't have email we should ask for email
      if (!userData.email) {
        if (afterVerifyData.exists) {
          setPhoneRoute(true);
          return setActiveTab(2);
        }

        return setActiveTab((c) => c + 1);
      }

      // If user doesn't have the grade we should ask for grade
      if (!userData.grade) {
        setValue("name", userData.name);

        // setIsPending(false);
        return setActiveTab(3);
      }

      setOtpCode("");
      setIsPending(false);
      // If user has email we should login the user
      // Starting with the rocket animation
      setLaunchRocket(true);
      // Logging in the user
      loginUser(userData);
    } catch (e) {
      console.log("e - ", e);
      // setOtpCode("");
      setIsPending(false);
      setError("phoneNumber", {
        message: e.message ?? "Something went wrong. Please try again later.",
      });
    }
  };

  const handleChangeOTP = async (_otpCode: string) => {
    setOtpCode(_otpCode);
    if (isPending || _otpCode.length !== 6) return;

    // Verifying OTP when otpCode is 6 digits
    verifyOTP(_otpCode);
  };

  return (
    <div className="slide__page">
      <div className="second__page__inner">
        <div className="top__area">
          <div>
            <button
              onClick={() => {
                props.reset();
              }}
            >
              <ArrowBackIosIcon />
            </button>
            <h6>My OTP is</h6>
          </div>
          {launchRocket && (
            <div className="launch__lottie">
              <Lottie options={{ loop: true, animationData: launch }} />
            </div>
          )}
          <button className="checking__otp">
            {!launchRocket && isPending && (
              <Lottie
                options={{ animationData: circularProgress, loop: true }}
              />
            )}
          </button>
          {allowNext && (
            <button onClick={() => setTimeout(() => setActiveTab(2), 250)}>
              <ArrowForwardIcon />
            </button>
          )}
        </div>

        <div className={"otp__input"}>
          {/* {formState.errors.phoneNumber && (
            <h5
              className="already__exists"
              style={{ color: "red", fontSize: "13px" }}
            >
              {formState.errors.phoneNumber?.message as string}
            </h5>
          )} */}
          {formState.errors.phoneExists && (
            <h5 className="already__exists">
              {formState.errors.phoneExists.message as string}
            </h5>
          )}
          {getValues("phoneNumber").length > 8 && (
            <h5 className="sent__to">
              Verification code sent to{" "}
              {"X".repeat(getValues("phoneNumber").length - 5) +
                getValues("phoneNumber").slice(
                  getValues("phoneNumber").length - 4,
                  getValues("phoneNumber").length
                )}
            </h5>
          )}
          <div>
            <div className="flex justify-center items-center scale-[0.7] md:scale-[1]">
              <OTPInput
                value={otpCode}
                onChange={handleChangeOTP}
                numInputs={6}
                shouldAutoFocus
                renderSeparator={
                  <span className="opacity-0">&emsp;&emsp;</span>
                }
                renderInput={(props) => (
                  <div
                    className={
                      "w-[50px] relative h-[54px] border-b-[3px] border-solid  transition-[border] ease-in-out focus-within:border-[white] " +
                      (formState.errors.phoneNumber
                        ? " border-b-red-500"
                        : " border-b-gray-600")
                    }
                  >
                    <input
                      {...props}
                      onFocus={() => clearErrors()}
                      className="h-[50px] w-[50px] text-center text-[rgb(0, 207, 0)]"
                      style={{
                        fontFamily: "digital",
                        fontSize: "44px",
                        backgroundColor: "transparent",
                        color: "rgb(0, 207, 0)",
                        textShadow: "0px 0px 8px rgba(255, 255, 0, 0.75)",
                        outline: "none",
                        border: "none",
                        borderRadius: 0,
                      }}
                    />
                  </div>
                )}
              />
            </div>
          </div>
          {formState.errors.phoneNumber && (
            <h6
              style={{
                visibility: "visible",
                color: "red",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "20px",
                fontSize: "14px",
              }}
            >
              <WarningRoundedIcon className="-mt-1 mr-2" />{" "}
              {formState.errors.phoneNumber?.message as string}
            </h6>
          )}
        </div>
        <div className="planets__wrapper">
          {planetsArray.map((planet, i) => (
            <Image
              height={100}
              width={100}
              key={i}
              alt={`planet${i + 1}`}
              className={`planet${i + 1}${
                otpCode[i]?.length > 0 ? handMovementClasses[i + 1] : ""
              }`}
              src={planet}
              draggable={false}
            />
          ))}
        </div>
        <div className="enter__code">
          <Image
            height={100}
            width={100}
            alt="code-vault"
            className="code"
            src={phoneVerification}
            draggable={false}
          />
          <h6 className={`tapBg ${handMovementClasses[lastInput]}`}></h6>
          <Image
            height={100}
            width={100}
            alt="phoneVerificationHand"
            className={`hand ${handMovementClasses[lastInput]}`}
            src={phoneVerificationHand}
            draggable={false}
          />

          <Image
            height={100}
            width={100}
            src={planetEarth}
            className="earth"
            alt="planetEarth"
            draggable={false}
          />

          <div className={resendCode ? "resend__code grey" : "resend__code"}>
            {props.isOpenAndActive && (
              <Timer
                initialTime={30100}
                direction="backward"
                checkpoints={[
                  { time: 1500, callback: () => setPlural(false) },
                  { time: 1100, callback: () => setResendCode(false) },
                ]}
              >
                {({ start, reset }) => (
                  <>
                    <h4
                      onClick={() => {
                        if (!resendCode) {
                          setPlural(true);
                          reset();
                          start();
                          setResendCode(true);
                          handleSignInWithPhone();
                        }
                      }}
                    >
                      Resend Code{resendCode ? "?" : ""}
                    </h4>

                    {resendCode ? (
                      <h6>
                        Tap resend in <Timer.Seconds />{" "}
                        {plural ? "seconds" : "second"}
                      </h6>
                    ) : (
                      <h6
                        onClick={() => {
                          if (!resendCode) {
                            setPlural(true);
                            reset();
                            start();
                            setResendCode(true);
                            handleSignInWithPhone();
                          }
                        }}
                      >
                        Tap here
                      </h6>
                    )}
                  </>
                )}
              </Timer>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default forwardRef(MyOtpIsStep);
